export enum E_InsertMode {
    Auto = 'Auto',
    Manual = 'Manual',
    Mix = 'Mix'
}
